const now = new Date();
const daysFromNow = (d) => { const dt = new Date(now); dt.setDate(dt.getDate() + d); return dt.toISOString(); };

export const trainingCourses = [
  // â”€â”€ Course 1: Product Compliance â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  {
    id: 'course-product-compliance',

    title: 'Product Compliance Basics',
    description: 'Mandatory compliance onboarding covering product suitability, disclosures, and ethical sales conduct required for all agents.',
    estimatedMinutes: 55,
    deadlineAt: daysFromNow(3),
    examDeadlineAt: daysFromNow(5),
    category: 'Compliance',
    color: '#752F87',
    modules: [
      {
        id: 'mod-pc-1',
        title: 'Introduction to Compliance',
        sections: [
          {
            id: 'sec-pc-1-1',
            title: 'What is Product Compliance?',
            type: 'content',
            estimatedMinutes: 5,
            content: `<h2>What is Product Compliance?</h2><p>Product compliance is the practice of meeting all legal, regulatory, and internal standards when recommending or selling insurance products. It ensures every client receives a product that genuinely matches their needs and financial profile.</p><p>In StarLife, compliance covers three core areas:</p><ul><li><strong>Suitability:</strong> Every product must be assessed as appropriate for the client before recommendation.</li><li><strong>Disclosure:</strong> All material terms, exclusions, premiums, and benefits must be communicated clearly and in writing.</li><li><strong>Documentation:</strong> Accurate records of all client interactions, needs analyses, and consent must be maintained.</li></ul><div class="tc-callout-warn">Non-compliance can result in regulatory sanctions, loss of your agent licence, reputational damage to StarLife, and direct financial harm to clients.</div>`,
          },
          {
            id: 'sec-pc-1-2',
            title: 'Why Compliance Matters',
            type: 'content',
            estimatedMinutes: 5,
            content: `<h2>Why Compliance Matters</h2><p>Compliance is the foundation of client trust in the insurance industry. As an agent, you are the primary point of contact for clients making important long-term financial decisions.</p><p><strong>For clients:</strong> Compliance protects them from unsuitable products, hidden exclusions, and aggressive sales practices.</p><p><strong>For StarLife:</strong> It maintains the company's regulatory licence, market reputation, and financial stability. Breaches can result in industry fines and forced product withdrawals.</p><p><strong>For you:</strong> Compliance protects your licence to operate, commission eligibility, and long-term career.</p><div class="tc-callout">Agents with strong compliance records earn higher client trust, better referrals, and are prioritised for leadership roles within StarLife.</div>`,
          },
          {
            id: 'sec-pc-1-pdf',
            title: 'Compliance Policy Reference Document',
            type: 'pdf',
            estimatedMinutes: 10,
            description: 'Review the compliance policy reference document below before proceeding to the suitability assessment module.',
            pdfUrl: '/assets/documents/training-product-compliance-reference.pdf',
          },
        ],
      },
      {
        id: 'mod-pc-2',
        title: 'Suitability and Disclosure',
        sections: [
          {
            id: 'sec-pc-2-1',
            title: 'Conducting Suitability Assessments',
            type: 'content',
            estimatedMinutes: 10,
            content: `<h2>Conducting Suitability Assessments</h2><p>Before recommending any product you are legally required to complete a formal suitability assessment. This ensures the product you recommend genuinely aligns with the client's financial situation, objectives, and risk tolerance.</p><ol><li>Gather complete financial details â€” income, existing savings, debts, and dependents.</li><li>Understand the client's primary objectives â€” protection, savings, education, retirement, or estate planning.</li><li>Assess the client's capacity and willingness to pay the required premium consistently.</li><li>Document all findings in the StarLife Needs Analysis Form and obtain the client's signature.</li><li>Recommend only the product(s) that are demonstrably suitable based on the documented assessment.</li></ol><div class="tc-callout-warn">Never recommend a product you cannot justify as suitable in writing. If challenged later, your signed Needs Analysis Form is your primary defence.</div>`,
          },
          {
            id: 'sec-pc-2-2',
            title: 'Disclosure Obligations',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>Disclosure Obligations</h2><p>You are legally required to disclose all material information to clients in writing before they sign any application. Omitting or downplaying key information is a compliance breach regardless of intent.</p><p>Required disclosures include:</p><ul><li>Premium amounts, frequency, and any escalation clauses.</li><li>Policy exclusions, waiting periods, and limitations on claims.</li><li>Surrender values, maturity values, and penalties for early termination.</li><li>The claims process, required documentation, and expected timelines.</li><li>Your identity, your agency number, and your relationship with StarLife.</li></ul><div class="tc-callout-warn">Failure to disclose can void a client's policy, trigger regulatory action against you personally, and result in StarLife bearing the financial liability.</div>`,
          },
          {
            id: 'sec-pc-2-3',
            title: 'Section Knowledge Check',
            type: 'quiz',
            estimatedMinutes: 6,
            feedbackMode: 'immediate',
            questions: [
              {
                id: 'q-pc-2-1',
                question: 'What must be completed and signed before recommending a product to a client?',
                options: [
                  { id: 'a', label: 'A suitability assessment and Needs Analysis Form' },
                  { id: 'b', label: 'A verbal agreement with the client' },
                  { id: 'c', label: 'A credit check from the bank' },
                ],
                correctOptionId: 'a',
              },
              {
                id: 'q-pc-2-2',
                question: 'Which of the following is a mandatory disclosure before policy signing?',
                options: [
                  { id: 'a', label: 'Your personal performance targets' },
                  { id: 'b', label: 'Policy exclusions and claims timelines' },
                  { id: 'c', label: 'Competitor product comparisons' },
                ],
                correctOptionId: 'b',
              },
              {
                id: 'q-pc-2-3',
                type: 'true_false',
                question: 'An agent can recommend a product without completing a Needs Analysis Form if the client verbally agrees.',
                correctAnswer: false,
              },
            ],
          },
        ],
      },
      {
        id: 'mod-pc-3',
        title: 'Final Assessment',
        sections: [
          { id: 'sec-pc-3-1', title: 'Course Exam', type: 'exam', estimatedMinutes: 15 },
        ],
      },
    ],
  },

  // â”€â”€ Course 2: AML Foundation â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  {
    id: 'course-aml-foundation',
    title: 'AML and KYC Foundation',
    description: 'Anti-money laundering and know-your-customer refresher training mandatory for all StarLife agents.',
    estimatedMinutes: 40,
    deadlineAt: daysFromNow(1),
    examDeadlineAt: daysFromNow(2),
    category: 'Regulatory',
    color: '#1D4ED8',
    modules: [
      {
        id: 'mod-aml-1',
        title: 'AML Fundamentals',
        sections: [
          {
            id: 'sec-aml-1-1',
            title: 'Understanding Money Laundering',
            type: 'content',
            estimatedMinutes: 7,
            content: `<h2>Understanding Money Laundering</h2><p>Money laundering is the process of making illegally obtained funds appear legitimate. Insurance products are attractive laundering vehicles because they involve the movement of large sums and generate legitimate-looking financial instruments.</p><p>The three stages of money laundering are:</p><ol><li><strong>Placement:</strong> Criminal proceeds are introduced into the financial system â€” for example, paying insurance premiums in cash from unknown sources.</li><li><strong>Layering:</strong> The trail is obscured through complex transactions â€” such as rapidly moving funds between policies, accounts, or jurisdictions.</li><li><strong>Integration:</strong> The funds re-enter the economy as apparently legitimate income â€” for example, receiving a surrender value or claims payout.</li></ol><div class="tc-callout-warn">As an agent, you are the first line of defence. Knowingly facilitating money laundering carries criminal penalties including imprisonment.</div>`,
          },
          {
            id: 'sec-aml-1-2',
            title: 'Red Flags to Watch For',
            type: 'content',
            estimatedMinutes: 6,
            content: `<h2>Red Flags to Watch For</h2><p>Certain client behaviours and transaction patterns should immediately alert you to potential AML risk. You are not required to investigate â€” you are required to report.</p><ul><li>Large cash premium payments with no verifiable income source.</li><li>Clients requesting early surrender or policy loans shortly after inception.</li><li>Third-party premium payments with no clear or credible relationship to the policyholder.</li><li>Clients who are reluctant, evasive, or hostile when asked to provide identity documents.</li><li>Policy amounts, premiums, or benefits inconsistent with the client's stated occupation or income.</li><li>Clients who show little interest in product details but focus only on how to withdraw funds.</li></ul><div class="tc-callout">When in doubt, complete and submit a Suspicious Transaction Report (STR) immediately to the Compliance team. You are protected from liability when acting in good faith.</div>`,
          },
          {
            id: 'sec-aml-1-audio',
            title: 'AML Awareness â€” Audio Summary',
            type: 'audio',
            estimatedMinutes: 5,
            description: 'Listen to this audio summary of AML fundamentals before proceeding to the KYC section.',
            audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
          },
        ],
      },
      {
        id: 'mod-aml-2',
        title: 'KYC Process',
        sections: [
          {
            id: 'sec-aml-2-1',
            title: 'KYC Documentation Requirements',
            type: 'content',
            estimatedMinutes: 7,
            content: `<h2>KYC Documentation Requirements</h2><p>Know Your Customer (KYC) is a mandatory verification process to confirm every client's identity and financial profile before onboarding.</p><p><strong>Standard KYC documents required for all clients:</strong></p><ul><li>Valid government-issued photo ID â€” passport, national ID card, or driver's licence.</li><li>Proof of residential address â€” utility bill or bank statement, not older than 3 months.</li></ul><p><strong>Enhanced Due Diligence â€” required for high-risk clients:</strong></p><ul><li>Source of funds declaration for monthly premiums above GH 5,000.</li><li>PEP (Politically Exposed Person) screening for clients in public office or related to same.</li><li>Business registration documents for corporate policyholders.</li></ul><div class="tc-callout-warn">You must never onboard a client without completing KYC. Incomplete KYC is itself a regulatory offence, even if no laundering is involved.</div>`,
          },
          {
            id: 'sec-aml-2-2',
            title: 'Section Knowledge Check',
            type: 'quiz',
            estimatedMinutes: 6,
            feedbackMode: 'immediate',
            questions: [
              {
                id: 'q-aml-2-1',
                question: 'When must you file a Suspicious Transaction Report (STR)?',
                options: [
                  { id: 'a', label: 'Only after written approval from your branch manager' },
                  { id: 'b', label: 'Immediately when you identify an AML red flag' },
                  { id: 'c', label: 'At your monthly compliance review meeting' },
                ],
                correctOptionId: 'b',
              },
              {
                id: 'q-aml-2-2',
                type: 'true_false',
                question: 'You are protected from personal liability when filing a Suspicious Transaction Report in good faith.',
                correctAnswer: true,
              },
              {
                id: 'q-aml-2-3',
                type: 'short_answer',
                question: 'What does "STR" stand for in the context of AML compliance reporting?',
                keywords: ['suspicious transaction report'],
                sampleAnswer: 'Suspicious Transaction Report',
              },
            ],
          },
          {
            id: 'sec-aml-2-3',
            title: 'Course Exam',
            type: 'exam',
            estimatedMinutes: 10,
          },
        ],
      },
    ],
  },

  // â”€â”€ Course 3: Customer Experience â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  {
    id: 'course-customer-experience',
    title: 'Customer Experience Essentials',
    description: 'Service quality standards, complaint handling procedures, and communication best practices for StarLife field agents.',
    estimatedMinutes: 45,
    deadlineAt: daysFromNow(7),
    examDeadlineAt: daysFromNow(9),
    category: 'Service',
    color: '#059669',
    modules: [
      {
        id: 'mod-cx-1',
        title: 'Service Standards',
        sections: [
          {
            id: 'sec-cx-1-1',
            title: 'StarLife Service Standards',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>StarLife Service Standards</h2><p>Every client interaction is a direct representation of the StarLife brand. Consistent, high-quality service builds the trust that drives client retention, referrals, and long-term agency success.</p><p><strong>Core service standards all agents must maintain:</strong></p><ul><li>Respond to all client inquiries within <strong>24 hours</strong> â€” even if just to acknowledge receipt and give a timeline.</li><li>Arrive punctually and professionally prepared for all scheduled client meetings.</li><li>Provide written confirmation of all policy changes, premium adjustments, or service requests.</li><li>Never make verbal commitments not backed by the policy document or an approved StarLife communication.</li><li>Follow up on all pending business within 48 hours of submission.</li></ul><div class="tc-callout">Agents ranked in the top quartile for client service retention consistently earn 40% more in renewal commissions than the agent average.</div>`,
          },
          {
            id: 'sec-cx-1-2',
            title: 'Effective Client Communication',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>Effective Client Communication</h2><p>Insurance products can be complex. Your communication style should leave clients feeling confident and clearly informed â€” not confused, pressured, or overwhelmed.</p><ol><li><strong>Use plain language.</strong> Avoid technical jargon unless you immediately explain it in everyday terms.</li><li><strong>Listen actively.</strong> Understand the client's actual concerns before presenting any product solution.</li><li><strong>Confirm understanding.</strong> After key discussions, ask the client to summarise what they understood â€” this reveals gaps before commitment.</li><li><strong>Provide written summaries.</strong> Follow all significant meetings with a brief written recap of what was agreed.</li><li><strong>Be honest about limitations.</strong> Clearly explain what a product does NOT cover. Clients who feel misled become complainants.</li></ol><div class="tc-callout-warn">Overpromising or understating exclusions to close a sale is a compliance breach. It can result in both regulatory sanctions and personal liability.</div>`,
          },
          {
            id: 'sec-cx-1-slides',
            title: 'Service Excellence â€” Slide Deck',
            type: 'slides',
            estimatedMinutes: 7,
            slides: [
              {
                id: 'sl-1',
                title: 'What is Service Excellence?',
                content: '<p>Service excellence is about consistently <strong>exceeding customer expectations</strong> at every touchpoint. It is a commitment to quality, responsiveness, and genuine care for every client\'s needs.</p><p>At StarLife, service excellence is not a department â€” it is a <strong>personal standard</strong> every agent upholds on every call, every meeting, and every follow-up.</p>',
              },
              {
                id: 'sl-2',
                title: 'The 3 Pillars of StarLife Service',
                content: '<ul><li><strong>Responsiveness:</strong> Acknowledge all client inquiries within 24 hours, no exceptions.</li><li><strong>Accuracy:</strong> Provide only verified, written information. Never guess on policy details.</li><li><strong>Empathy:</strong> Listen actively before offering any solution. Clients want to feel heard first.</li></ul><div class="tc-callout">Agents who score highest on empathy in client surveys generate 32% more referrals than the company average.</div>',
              },
              {
                id: 'sl-3',
                title: 'Measuring Your Service Performance',
                content: '<p>Your service quality is continuously tracked through:</p><ol><li>Client satisfaction surveys after every policy review or complaint resolution.</li><li>Complaint resolution rate â€” target: 100% resolved within 5 business days.</li><li>Policy renewal rate â€” your single strongest indicator of client trust.</li><li>Net Promoter Score (NPS) â€” would your clients recommend StarLife to others?</li></ol>',
              },
              {
                id: 'sl-4',
                title: 'The Service Recovery Paradox',
                content: '<div class="tc-callout">Research consistently shows that clients whose complaints are resolved quickly and fairly are <strong>more loyal</strong> than clients who never had a complaint. Every complaint is an opportunity to deepen trust.</div><p>The key is <strong>speed and sincerity</strong>: respond within 24 hours, resolve within 5 business days, and always communicate in writing.</p>',
              },
            ],
          },
        ],
      },
      {
        id: 'mod-cx-2',
        title: 'Complaint Handling',
        sections: [
          {
            id: 'sec-cx-2-1',
            title: 'Handling Client Complaints',
            type: 'content',
            estimatedMinutes: 7,
            content: `<h2>Handling Client Complaints</h2><p>Complaints, when handled correctly, are powerful opportunities to strengthen client loyalty. Research consistently shows that clients whose complaints are resolved promptly and professionally are often more loyal than those who never complained.</p><p><strong>The StarLife Complaint Handling Process:</strong></p><ol><li><strong>Acknowledge immediately.</strong> Thank the client for raising the issue. Do not be defensive or dismissive.</li><li><strong>Log accurately.</strong> Record all complaint details â€” date, nature of the issue, client identity, and related policy numbers â€” immediately and in full.</li><li><strong>Investigate thoroughly.</strong> Gather all relevant policy documents, application forms, and prior communications before forming a view.</li><li><strong>Resolve clearly.</strong> Provide a written, plain-language response within 5 business days.</li><li><strong>Escalate promptly.</strong> If the complaint is beyond your authority, escalate to your branch manager within 24 hours.</li></ol><div class="tc-callout">Never promise a specific outcome before completing your investigation. Premature promises that cannot be honoured turn a complaint into a regulatory issue.</div>`,
          },
          {
            id: 'sec-cx-2-2',
            title: 'Section Knowledge Check',
            type: 'quiz',
            estimatedMinutes: 6,
            feedbackMode: 'delayed',
            questions: [
              {
                id: 'q-cx-2-1',
                question: 'What is the correct first step when a client raises a complaint?',
                options: [
                  { id: 'a', label: 'Deny responsibility and explain why the client is wrong' },
                  { id: 'b', label: 'Acknowledge the complaint and log all details immediately' },
                  { id: 'c', label: 'Transfer the client to a colleague to handle' },
                ],
                correctOptionId: 'b',
              },
              {
                id: 'q-cx-2-2',
                type: 'true_false',
                question: 'It is acceptable to promise a specific outcome to a client before completing your investigation of their complaint.',
                correctAnswer: false,
              },
              {
                id: 'q-cx-2-3',
                type: 'short_answer',
                question: 'Within how many business days must a written complaint resolution be provided to a client?',
                keywords: ['5', 'five'],
                sampleAnswer: '5 business days',
              },
              {
                id: 'q-cx-2-4',
                type: 'matching',
                question: 'Match each service obligation to the correct timeframe',
                pairs: [
                  { left: { id: 'cx-l1', text: 'Client inquiry acknowledgement' }, right: { id: 'cx-r1', text: 'Within 24 hours' } },
                  { left: { id: 'cx-l2', text: 'Written complaint resolution' }, right: { id: 'cx-r2', text: 'Within 5 business days' } },
                  { left: { id: 'cx-l3', text: 'Escalation to branch manager' }, right: { id: 'cx-r3', text: 'Same day (within 24 hours)' } },
                ],
              },
            ],
          },
          {
            id: 'sec-cx-2-3',
            title: 'Course Exam',
            type: 'exam',
            estimatedMinutes: 10,
          },
        ],
      },
    ],
  },

  // â”€â”€ Course 4: Life Insurance Products â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  {
    id: 'course-life-insurance-products',
    title: 'StarLife Product Suite Overview',
    description: 'A comprehensive overview of StarLife\'s full product range â€” term, whole life, endowment, education plans, and pension products.',
    estimatedMinutes: 60,
    deadlineAt: daysFromNow(14),
    examDeadlineAt: daysFromNow(16),
    category: 'Products',
    color: '#2563EB',
    modules: [
      {
        id: 'mod-lip-1',
        title: 'Protection Products',
        sections: [
          {
            id: 'sec-lip-1-1',
            title: 'Term Life Insurance',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>Term Life Insurance</h2><p>Term life insurance provides pure death benefit coverage for a defined period. It is the most affordable form of life insurance and is ideal for income replacement during peak earning years.</p><p><strong>Key features:</strong></p><ul><li>Coverage periods: 5, 10, 15, or 20 years.</li><li>Fixed premium for the duration of the term.</li><li>No cash value accumulation.</li><li>Benefit paid as a lump sum to named beneficiaries on death within the term.</li></ul><div class="tc-callout">Term life is ideal for clients who need maximum coverage at the lowest cost â€” particularly young families or those with large mortgages or business loans.</div>`,
          },
          {
            id: 'sec-lip-1-2',
            title: 'Whole Life Insurance',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>Whole Life Insurance</h2><p>Whole life insurance provides lifelong coverage combined with a savings component that builds cash value over time.</p><p><strong>Key features:</strong></p><ul><li>Permanent coverage â€” does not expire as long as premiums are paid.</li><li>Builds guaranteed cash value over time.</li><li>Policy loans available against the accumulated cash value.</li><li>Higher premiums than term life but includes both protection and savings.</li></ul><div class="tc-callout-warn">Always explain the difference between death benefit and cash surrender value clearly to clients. Clients sometimes confuse the two.</div>`,
          },
          {
            id: 'sec-lip-1-3',
            title: 'Knowledge Check',
            type: 'quiz',
            estimatedMinutes: 5,
            feedbackMode: 'immediate',
            questions: [
              { id: 'q-lip-1-1', question: 'Which product builds cash value over time?', options: [{ id: 'a', label: 'Term life insurance' }, { id: 'b', label: 'Whole life insurance' }, { id: 'c', label: 'Group credit life' }], correctOptionId: 'b' },
              { id: 'q-lip-1-2', type: 'true_false', question: 'Term life insurance accumulates cash value.', correctAnswer: false },
            ],
          },
        ],
      },
      {
        id: 'mod-lip-2',
        title: 'Savings & Investment Products',
        sections: [
          {
            id: 'sec-lip-2-1',
            title: 'Endowment Plans',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>Endowment Plans</h2><p>Endowment plans combine life insurance protection with a disciplined savings plan that matures at a specific date. The client receives the maturity benefit whether they survive to the end of the term or not (as a death benefit to beneficiaries).</p><ul><li>Guaranteed maturity benefit if the policyholder survives the term.</li><li>Death benefit paid to beneficiaries if the policyholder dies during the term.</li><li>Common terms: 10, 15, 20 years.</li></ul><div class="tc-callout">Endowment plans are popular for goal-oriented savings such as education, home ownership, or retirement supplementation.</div>`,
          },
          {
            id: 'sec-lip-2-2',
            title: 'Education Plans',
            type: 'content',
            estimatedMinutes: 6,
            content: `<h2>Education Plans</h2><p>Education plans are specially structured endowment products designed to fund a child's tertiary education. The plan matures when the child reaches the target university entry age (typically 18).</p><p><strong>Key selling points:</strong></p><ul><li>Guaranteed education fund regardless of what happens to the parent/policyholder.</li><li>Waiver of premium benefit â€” premiums continue to be paid by the insurer if the parent dies or becomes disabled.</li><li>Transparent illustration of projected maturity values.</li></ul>`,
          },
          {
            id: 'sec-lip-2-3',
            title: 'Course Exam',
            type: 'exam',
            estimatedMinutes: 10,
          },
        ],
      },
    ],
  },

  // â”€â”€ Course 5: Pension Products â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  {
    id: 'course-pension-products',
    title: 'Pension & Retirement Planning',
    description: 'Understanding StarLife\'s pension products, retirement planning principles, and regulatory requirements under NPRA.',
    estimatedMinutes: 50,
    deadlineAt: daysFromNow(21),
    examDeadlineAt: daysFromNow(23),
    category: 'Products',
    color: '#0891B2',
    modules: [
      {
        id: 'mod-pp-1',
        title: 'Ghana Pension Framework',
        sections: [
          {
            id: 'sec-pp-1-1',
            title: 'The Three-Tier Pension System',
            type: 'content',
            estimatedMinutes: 10,
            content: `<h2>Ghana's Three-Tier Pension System</h2><p>Ghana's pension framework operates on three tiers, regulated by the National Pensions Regulatory Authority (NPRA).</p><ul><li><strong>Tier 1 â€” Basic Social Security:</strong> Mandatory. Managed by SSNIT. 13.5% of basic salary (employer: 13%, employee: 5.5%).</li><li><strong>Tier 2 â€” Occupational Pension:</strong> Mandatory for formal sector workers. 5% of basic salary, managed by licensed trustees including insurance companies.</li><li><strong>Tier 3 â€” Voluntary Provident Funds:</strong> Voluntary top-up savings. Managed by licensed trustees. Tax incentives available for contributions.</li></ul><div class="tc-callout">StarLife operates as a licensed Tier 2 and Tier 3 pension trustee. Agents selling pension products must understand this framework thoroughly.</div>`,
          },
          {
            id: 'sec-pp-1-2',
            title: 'StarLife Pension Products',
            type: 'content',
            estimatedMinutes: 8,
            content: `<h2>StarLife Pension Products</h2><p>StarLife offers both Tier 2 and Tier 3 pension solutions for individuals and corporate groups.</p><p><strong>Group Pension:</strong> Corporate clients with 5+ employees. Employer-sponsored contributions with optional employee top-up. Ideal for SMEs and large corporates who want to attract and retain staff.</p><p><strong>Personal Pension Plan:</strong> Tier 3 voluntary plan for individuals â€” especially informal sector workers with no employer-sponsored pension. Flexible contribution amounts and frequency.</p>`,
          },
          {
            id: 'sec-pp-1-3',
            title: 'Knowledge Check',
            type: 'quiz',
            estimatedMinutes: 5,
            feedbackMode: 'immediate',
            questions: [
              { id: 'q-pp-1-1', question: 'Which tier covers mandatory occupational pension contributions?', options: [{ id: 'a', label: 'Tier 1' }, { id: 'b', label: 'Tier 2' }, { id: 'c', label: 'Tier 3' }], correctOptionId: 'b' },
              { id: 'q-pp-1-2', type: 'true_false', question: 'Tier 3 pension contributions are mandatory for all formal sector workers.', correctAnswer: false },
            ],
          },
        ],
      },
      {
        id: 'mod-pp-2',
        title: 'Selling Pension Products',
        sections: [
          {
            id: 'sec-pp-2-1',
            title: 'Identifying Pension Prospects',
            type: 'content',
            estimatedMinutes: 6,
            content: `<h2>Identifying Pension Prospects</h2><p>Not every client needs the same pension solution. Effective pension selling starts with prospect identification.</p><ul><li><strong>Informal sector workers:</strong> Traders, artisans, self-employed professionals â€” most lack any pension. Tier 3 personal pension is ideal.</li><li><strong>SME employers:</strong> Small business owners who want to attract talent with pension benefits. Group pension pitch.</li><li><strong>Young formal sector employees:</strong> Tier 2 top-up or voluntary Tier 3 to supplement mandatory contributions.</li></ul>`,
          },
          {
            id: 'sec-pp-2-2',
            title: 'Course Exam',
            type: 'exam',
            estimatedMinutes: 10,
          },
        ],
      },
    ],
  },

];
export const trainingExams = {
  'course-product-compliance': {
    id: 'exam-product-compliance',
    passMark: 70,
    feedbackMode: 'immediate',
    questions: [
      {
        id: 'q1',
        question: 'Which step is mandatory before recommending any insurance product?',
        options: [
          { id: 'a', label: 'Give the client a verbal premium quote only' },
          { id: 'b', label: 'Complete a formal suitability assessment' },
          { id: 'c', label: 'Skip the needs analysis for existing clients' },
        ],
        correctOptionId: 'b',
      },
      {
        id: 'q2',
        question: 'Which of the following represents a compliance risk in the sales process?',
        options: [
          { id: 'a', label: 'Documenting client consent before policy inception' },
          { id: 'b', label: 'Clearly explaining benefit terms to the client' },
          { id: 'c', label: 'Misrepresenting or omitting policy exclusions' },
        ],
        correctOptionId: 'c',
      },
      {
        id: 'q3',
        question: 'The Needs Analysis Form must be signed by:',
        options: [
          { id: 'a', label: 'The agent only' },
          { id: 'b', label: 'Both the agent and the client' },
          { id: 'c', label: 'The branch manager only' },
        ],
        correctOptionId: 'b',
      },
    ],
  },
  'course-aml-foundation': {
    id: 'exam-aml-foundation',
    passMark: 60,
    feedbackMode: 'immediate',
    questions: [
      {
        id: 'q1',
        question: 'When should suspicious transactions be escalated?',
        options: [
          { id: 'a', label: 'Only after client confirmation' },
          { id: 'b', label: 'Immediately through the Compliance reporting channel' },
          { id: 'c', label: 'At month-end reconciliation' },
        ],
        correctOptionId: 'b',
      },
      {
        id: 'q2',
        question: 'KYC verification primarily ensures:',
        options: [
          { id: 'a', label: 'Client identity verification and risk profiling' },
          { id: 'b', label: 'Higher commission rates for the agent' },
          { id: 'c', label: 'That no documentation is needed for the file' },
        ],
        correctOptionId: 'a',
      },
      {
        id: 'q3',
        question: 'Which of the following is NOT considered an AML red flag?',
        options: [
          { id: 'a', label: 'Client proactively provides all required KYC documents' },
          { id: 'b', label: 'Large cash payment with no verifiable income source' },
          { id: 'c', label: 'Client requests early surrender shortly after policy inception' },
        ],
        correctOptionId: 'a',
      },
    ],
  },
  'course-customer-experience': {
    id: 'exam-customer-experience',
    passMark: 75,
    feedbackMode: 'delayed',
    questions: [
      {
        id: 'q1',
        question: 'The best first response to a client complaint is to:',
        options: [
          { id: 'a', label: 'Acknowledge the issue and log all details immediately' },
          { id: 'b', label: 'Promise an immediate payout to resolve it' },
          { id: 'c', label: 'Ignore it until the client escalates formally' },
        ],
        correctOptionId: 'a',
      },
      {
        id: 'q2',
        question: 'Effective client service communication should be:',
        options: [
          { id: 'a', label: 'Ambiguous to avoid creating liability' },
          { id: 'b', label: 'Clear, accurate, and delivered in a timely manner' },
          { id: 'c', label: 'Technical and detailed, without context for the client' },
        ],
        correctOptionId: 'b',
      },
      {
        id: 'q3',
        question: 'Client inquiries must be responded to within:',
        options: [
          { id: 'a', label: '1 week from receipt' },
          { id: 'b', label: '72 hours from receipt' },
          { id: 'c', label: '24 hours from receipt' },
        ],
        correctOptionId: 'c',
      },
    ],
  },

  'course-life-insurance-products': {
    id: 'exam-life-insurance-products',
    passMark: 70,
    feedbackMode: 'immediate',
    questions: [
      { id: 'q1', question: 'Which type of insurance provides coverage for a defined period only?', options: [{ id: 'a', label: 'Whole life' }, { id: 'b', label: 'Term life' }, { id: 'c', label: 'Endowment' }], correctOptionId: 'b' },
      { id: 'q2', question: 'An endowment plan pays a maturity benefit when:', options: [{ id: 'a', label: 'The policyholder dies only' }, { id: 'b', label: 'The policyholder survives to the end of the policy term' }, { id: 'c', label: 'The policyholder surrenders early' }], correctOptionId: 'b' },
      { id: 'q3', question: 'An education plan typically includes a waiver of premium that pays premiums if the:', options: [{ id: 'a', label: 'Child fails school exams' }, { id: 'b', label: 'Parent dies or becomes disabled' }, { id: 'c', label: 'Inflation rises above 10%' }], correctOptionId: 'b' },
    ],
  },

  'course-pension-products': {
    id: 'exam-pension-products',
    passMark: 70,
    feedbackMode: 'immediate',
    questions: [
      { id: 'q1', question: 'Who regulates pension schemes in Ghana?', options: [{ id: 'a', label: 'NIC' }, { id: 'b', label: 'Bank of Ghana' }, { id: 'c', label: 'NPRA' }], correctOptionId: 'c' },
      { id: 'q2', question: 'A self-employed trader with no employer should be recommended:', options: [{ id: 'a', label: 'Tier 1 SSNIT only' }, { id: 'b', label: 'Tier 3 voluntary personal pension' }, { id: 'c', label: 'Tier 2 occupational scheme' }], correctOptionId: 'b' },
      { id: 'q3', question: 'Tier 3 pension contributions are:', options: [{ id: 'a', label: 'Mandatory for all workers' }, { id: 'b', label: 'Voluntary and tax-incentivised' }, { id: 'c', label: 'Managed exclusively by SSNIT' }], correctOptionId: 'b' },
    ],
  },
};

// â”€â”€ Removed courses (6â€“23) exam stubs kept here so git history is clean â”€â”€â”€â”€
export const defaultProgressState = {
  courses: {},
  exams: {},
  sectionTimes: {},
};
